var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 141,
    viewBox: "0 0 208 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 208,
    height: 140.577,
    rx: 4,
    fill: "#004552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8804,
    y: 21,
    width: 158.239,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8804,
    y: 90,
    width: 158.239,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8804,
    y: 55,
    width: 158.239,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1816 32.047H43.2176V41H41.8876V33.622C41.6543 33.7573 41.4163 33.8623 41.1736 33.937C40.9309 34.007 40.6883 34.0467 40.4456 34.056V32.768C40.7489 32.7307 41.0429 32.656 41.3276 32.544C41.6169 32.4273 41.9016 32.2617 42.1816 32.047Z",
    fill: "#004552"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0744 110.182C41.617 110.182 41.176 110.119 40.7514 109.993C40.3267 109.862 39.944 109.676 39.6034 109.433C39.2674 109.186 39.0014 108.88 38.8054 108.516C38.6094 108.147 38.5114 107.723 38.5114 107.242H39.8974C39.9114 107.606 40.014 107.916 40.2054 108.173C40.3967 108.43 40.6534 108.626 40.9754 108.761C41.2974 108.892 41.6637 108.957 42.0744 108.957C42.6904 108.957 43.1687 108.81 43.5094 108.516C43.8547 108.222 44.0274 107.853 44.0274 107.41C44.0274 107.125 43.955 106.876 43.8104 106.661C43.6704 106.446 43.4487 106.281 43.1454 106.164C42.8467 106.043 42.457 105.982 41.9764 105.982H40.8914V104.932H41.7174C42.3334 104.932 42.8187 104.806 43.1734 104.554C43.528 104.297 43.7054 103.95 43.7054 103.511C43.7054 103.119 43.5584 102.79 43.2644 102.524C42.9704 102.258 42.5434 102.125 41.9834 102.125C41.54 102.125 41.1457 102.216 40.8004 102.398C40.455 102.575 40.2264 102.895 40.1144 103.357H38.7354C38.8054 102.778 38.9874 102.309 39.2814 101.95C39.5754 101.591 39.951 101.329 40.4084 101.166C40.8657 101.003 41.3767 100.921 41.9414 100.921C42.5527 100.921 43.0987 101.026 43.5794 101.236C44.0647 101.441 44.445 101.728 44.7204 102.097C44.9957 102.466 45.1334 102.89 45.1334 103.371C45.1334 103.833 45.0027 104.232 44.7414 104.568C44.4847 104.899 44.109 105.154 43.6144 105.331C44.165 105.499 44.613 105.767 44.9584 106.136C45.3037 106.5 45.4764 106.962 45.4764 107.522C45.4764 108.04 45.3364 108.5 45.0564 108.901C44.7764 109.302 44.382 109.617 43.8734 109.846C43.3647 110.07 42.765 110.182 42.0744 110.182Z",
    fill: "#004552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.109 75V73.593C160.109 73.0843 160.189 72.6573 160.347 72.312C160.506 71.962 160.737 71.6703 161.04 71.437C161.344 71.2037 161.712 71.003 162.146 70.835L163.938 70.135C164.368 69.9623 164.687 69.743 164.897 69.477C165.107 69.211 165.212 68.882 165.212 68.49C165.212 68.084 165.07 67.748 164.785 67.482C164.501 67.216 164.097 67.083 163.574 67.083C163.066 67.083 162.643 67.1997 162.307 67.433C161.976 67.6617 161.787 68.0047 161.74 68.462H160.263C160.287 67.9067 160.441 67.44 160.725 67.062C161.01 66.684 161.395 66.3993 161.88 66.208C162.366 66.0167 162.923 65.921 163.553 65.921C164.141 65.921 164.669 66.033 165.135 66.257C165.602 66.481 165.971 66.7913 166.241 67.188C166.517 67.5847 166.654 68.042 166.654 68.56C166.654 69.022 166.57 69.4257 166.402 69.771C166.234 70.1117 165.987 70.408 165.66 70.66C165.334 70.912 164.937 71.1313 164.47 71.318L162.65 72.039C162.24 72.1977 161.934 72.3843 161.733 72.599C161.537 72.809 161.439 73.0843 161.439 73.425V73.775H166.584V75H160.109Z",
    fill: "#004552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots2);
export default __webpack_public_path__ + "static/media/slots-2.44a2cde8058e10a0425e5c0202d5132f.svg";
export { ForwardRef as ReactComponent };